import React from 'react'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from 'tss-react/mui'
import { Button, ButtonGroup, Typography } from '@mui/material'
import { Apps, Menu } from '@mui/icons-material'

import { ViewPreference } from '@src/routes/SearchResults/SearchResults'

const useStyles = makeStyles()((theme) => ({
  mobileViewToggle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: theme.spacing(4, 0),
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(6, 0, 4, 0),
    },
  },
  mobileTitle: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: 'bold',
  },
  mobileToggleControls: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  mobileToggleLabel: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(1),
  },
  mobileViewToggleButton: {
    borderRadius: '2px',
    padding: '8px',
    minWidth: '40px',
    border: `1px solid ${theme.palette.grey[400]}`,
  },
}))

interface MobileHeaderProps {
  view: ViewPreference | null
  handleSelectView: (view: ViewPreference) => void
}

const MobileHeader: React.FC<MobileHeaderProps> = ({
  view,
  handleSelectView,
}) => {
  const { classes } = useStyles()

  return (
    <div className={classes.mobileViewToggle}>
      <Typography className={classes.mobileTitle}>
        <FormattedMessage id="SELECT_A_SIZE" defaultMessage="Select a Size" />
      </Typography>
      <div className={classes.mobileToggleControls}>
        <Typography className={classes.mobileToggleLabel}>
          <FormattedMessage id="CHANGE_VIEW" defaultMessage="Change View" />
        </Typography>
        <ButtonGroup size="small">
          <Button
            variant={view === ViewPreference.list ? 'contained' : undefined}
            color="primary"
            onClick={() => handleSelectView(ViewPreference.list)}
            className={classes.mobileViewToggleButton}
          >
            <Menu />
          </Button>
          <Button
            variant={view === ViewPreference.grid ? 'contained' : undefined}
            color="primary"
            onClick={() => handleSelectView(ViewPreference.grid)}
            className={classes.mobileViewToggleButton}
          >
            <Apps />
          </Button>
        </ButtonGroup>
      </div>
    </div>
  )
}

export default MobileHeader
